import { filter, isEmpty, some } from 'lodash'

const getSubtypeNodesWithChildren = (keywordNode, subtypesToCheck) =>
  filter(keywordNode.children, node => {
    const hasChildren = node.isSubtype && !isEmpty(node.children)

    if (!isEmpty(subtypesToCheck)) {
      return (
        hasChildren && some(subtypesToCheck, ({ id }) => id === node.subtype)
      )
    }

    return hasChildren
  })

export default getSubtypeNodesWithChildren
